"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var check_box_1 = __importDefault(require("~/components/forms/common/check_box"));
var mobx_react_1 = require("mobx-react");
var FormFooter = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement("div", { className: "formsCommon-FormFooter_Container" },
        props.askUpdateNickname &&
            react_1.default.createElement(check_box_1.default, { label: "\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0\u3092\u767B\u9332\u60C5\u5831\u306B\u53CD\u6620\u3059\u308B", checked: props.store.updateNickname, onChange: function (checked) { props.store.updateNickname = checked; } }),
        react_1.default.createElement("button", { className: "formsCommon-FormFooter_SubmitButton", onClick: props.store.submitReview }, "\u30AF\u30C1\u30B3\u30DF\u3092\u6295\u7A3F\u3059\u308B"),
        react_1.default.createElement("div", { className: "formsCommon-FormFooter_Attention" },
            "\u6295\u7A3F\u3068\u540C\u6642\u306B",
            react_1.default.createElement("a", { href: "/review-term/", target: "_blank", rel: "noopener noreferrer nofollow" }, "\u30AF\u30C1\u30B3\u30DF\u5229\u7528\u898F\u7D04"),
            "\u306B\u540C\u610F\u3057\u305F\u3068\u307F\u306A\u3055\u308C\u307E\u3059")));
});
exports.default = FormFooter;
